import { createContext } from 'react';

/**
 * Tells a `Button` that a component around it shows a tooltip with content,
 * so a disabled or loading button stays focusable exactly as it does with its
 * own `tooltip` prop. For components that own the tooltip themselves, such as
 * `StatusButton`.
 */
export const DisabledTooltipContext = createContext(false);
